/**
 * Asserts that a condition is `true`, ensuring that whatever condition is being
 * checked must be true for the remainder of the containing scope.
 *
 * @throws when the condition is `false`
 */
// NOTE: The narrow type of `boolean` instead of something like `unknown` is an
// intentional design decision. The goal is to promote consideration from
// consumers when dealing with potentially ambiguous conditions like `0` or
// `''`, which can introduce "subtle" bugs.
function assert(condition) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Assert failed';

  if (!condition) {
    throw new TypeError(message);
  }
}
/**
 * Asserts that allegedly unreachable code has been executed.
 *
 * @throws always
 */

function assertNever(arg) {
  throw new Error('Expected never to be called, but received: ' + JSON.stringify(arg));
}
/**
 * Similar to `assert` but only logs a warning if the condition is not met. Only
 * logs in development.
 */

function warning(condition, message) {
  if (!(process.env.NODE_ENV === 'production')) {
    if (condition) {
      return;
    } // follow message prefix convention


    var text = "Warning: ".concat(message); // IE9 support, console only with open devtools

    if (typeof console !== 'undefined') {
      console.warn(text);
    } // NOTE: throw and catch immediately to provide a stack trace:
    // https://developer.chrome.com/blog/automatically-pause-on-any-exception/


    try {
      throw Error(text); // eslint-disable-next-line no-empty
    } catch (x) {}
  }
}

export { assert, assertNever, warning };
